export interface IPositionData {
  jobPostingUrl?: string;
  positionId?: string | null;
  skill?: string;
  specialization?: string;
  title?: string;
  utmProvider?: string;
  utmSource?: string;
  expireddate?: string;
  isDisplayable: boolean;
  detectedPosition?: DetectedPositionType;
  detectedSkills?: string[] | null;
  detectedSpecialization?: string | null;
}

export enum DetectedPositionType {
  PARTIAL = 'PARTIAL',
  FULL = 'FULL',
}
